import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=06a6ce0e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a6ce0e')) {
      api.createRecord('06a6ce0e', component.options)
    } else {
      api.reload('06a6ce0e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=06a6ce0e&", function () {
      api.rerender('06a6ce0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21G3p08TE0kFc/JS/videoIframe.vue"
export default component.exports